jQuery(($) => {
    if ($('.t-pa_brand__infographics-section')[0]) {
        $('.t-pa_brand__infographics-section__load-more').click(function () {
            $(this).parents('.t-pa_brand__infographics-section').removeClass('t-pa_brand__infographics-section--hide-products');
        });
    }
});